export default __webpack_public_path__ + "bdf4e68f122c1bdc8194b6a7fdec657c.png";